import { Box, Grid, Container, styled } from "@mui/material";

const TractorGreenIcon = require("assets/img/png/tractor_green_ic.png");
const SearchBookIcon = require("assets/img/png/search_book_ic.png");

const ThumbsUpIcon = require("assets/img/png/thumbsup_ic.png");
const FarmIcon = require("assets/img/png/farm_ic.png");
const ReturnIcon = require("assets/img/png/return_ic.png");

const TopBox = styled(Box)({
  display: "flex",
  justifyContent: "space-evenly",
  flexDirection: "row",
  paddingTop: 60,
  paddingBottom: 60,

  "& .content": {
    "& h5": {
      fontSize: 18,
      fontFamily: "Bayon",
      fontWeight: "normal",
      color: "#6E8C20",
      lineHeight: "33px",
      padding: 0,
      margin: 0,
      textTransform: "uppercase",
    },

    "& h1": {
      fontSize: 72,
      fontFamily: "Inter",
      fontWeight: "600",
      color: "#323232",
      lineHeight: "82px",
      padding: "0 0 30px",
      margin: 0,
      "& span": {
        color: "#6E8C20",
      },
    },

    "& .content-wrapper": {
      display: "flex",
      flexDirection: "row",
      padding: "0 0 40px",

      "& .content-icon": {
        width: 48,
        height: 48,
      },

      "& .content-text": {
        paddingLeft: 20,

        "& h4": {
          fontSize: 26,
          fontFamily: "Inter",
          fontWeight: "600",
          color: "#323232",
          lineHeight: "31px",
          padding: "0 0 20px",
          margin: 0,
        },
        "& p": {
          fontSize: 18,
          fontFamily: "Inter",
          fontWeight: "500",
          color: "#A2A2A2",
          lineHeight: "28px",
          padding: 0,
          margin: 0,
        },
      },
    },
  },
  "@media only screen and (min-width: 320px) and (max-width: 768px)": {
    paddingTop: 30,
    paddingBottom: 30,
    "& .content": {
      "& h5": {
        fontSize: 14,
        lineHeight: "25px",
        fontWeight: "400",
        padding: "0 0 10px",
      },
      "& h1": {
        fontSize: 26,
        lineHeight: "36px",
      },
      "& .content-wrapper": {
        padding: "0 0 0px",

        "& .content-icon": {
          width: 24,
          height: 24,
          "& img": {
            width: "inherit",
            height: "inherit",
          },
        },

        "& .content-text": {
          "& h4": {
            fontSize: 17,
            lineHeight: "21px",
            padding: "0 0 4px",
          },

          "& P": {
            fontSize: 15,
            lineHeight: "22px",
            fontWeight: "normal",
          },
        },
      },
    },
  },
});

const HowItWorks = () => {
  return (
    <div className="how-it-works">
      <TopBox>
        <Container>
          <div className="content">
            <h5>Renting a Tractor, Attachment or Equipment is easy</h5>
            <h1>
              <span>How</span> It Works
            </h1>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <div className="content-wrapper">
                  <div className="content-icon">
                    <img src={TractorGreenIcon} alt="tractor" />
                  </div>
                  <div className="content-text">
                    <h4>Find Your Perfect Farm Equipment</h4>
                    <p>
                      Your ideal farm equipment is just a few clicks away. Start
                      by browsing our wide range of available options to suit
                      your specific requirements. It’s that simple!
                    </p>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className="content-wrapper">
                  <div className="content-icon">
                    <img src={SearchBookIcon} alt="search book" />
                  </div>
                  <div className="content-text">
                    <h4>Book Your Equipment</h4>
                    <p>
                      Liked something? Send a request. Ask questions. Bundle
                      with additional attachments if needed. Streamline your
                      next farm project with ease.
                    </p>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <div className="content-wrapper">
                  <div className="content-icon">
                    <img src={ThumbsUpIcon} alt="thumbsup" />
                  </div>
                  <div className="content-text">
                    <h4>Pickup Or Get It Delivered</h4>
                    <p>
                      Choose pickup or delivery for unparalleled convenience,
                      ensuring your farming needs are met with maximum ease and
                      flexibility.
                    </p>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className="content-wrapper">
                  <div className="content-icon">
                    <img src={FarmIcon} alt="farm" />
                  </div>
                  <div className="content-text">
                    <h4>Hit The Farm!</h4>
                    <p>
                      Hit the farm and plow away with confidence, knowing your
                      tractor and other equipment are covered by our episodic
                      insurance.
                    </p>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <div className="content-wrapper">
                  <div className="content-icon">
                    <img src={ReturnIcon} alt="return" />
                  </div>
                  <div className="content-text">
                    <h4>Return</h4>
                    <p>
                      After completing your dream project, return the equipment
                      to the owner in its original condition.
                    </p>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </TopBox>
    </div>
  );
};

export default HowItWorks;
